<template>
    <div class="form-field-constructor">
        <Draggable :list="localFields" handle=".form-field-constructor-item__handle" tag="div" @change="emitValue">
            <FormFieldConstructorItem
                v-for="(field, index) in localFields"
                :key="field.__uid"
                :value="field"
                :position="index + 1"
                :dictionaries="dictionaries"
                @input="onItemInput(index, $event)"
                @remove="onItemRemove(index)"
            ></FormFieldConstructorItem>
        </Draggable>

        <p v-if="!localFields.length" class="form-field-constructor__empty">
            У услуги пока нет полей — заявитель увидит обычное поле «Описание». Добавьте поля, чтобы собрать форму.
        </p>

        <VButton type="button" class="button_green form-field-constructor__add" @click="addField">
            Добавить поле
        </VButton>
    </div>
</template>
<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import VButton from '@/views/components/VButton/VButton.vue';
import FormFieldConstructorItem from './FormFieldConstructorItem.vue';
import RequestServiceFormFieldType from '@/js/enums/RequestServiceFormFieldType';

let nextUid = 1;

@Component({
    components: { VButton, FormFieldConstructorItem },
})
class FormFieldConstructor extends Vue {
    @Prop({ type: Array, required: true }) value;
    // Dictionaries available to a select field's "Справочник" source; loaded once by the parent card.
    @Prop({ type: Array, default: () => [] }) dictionaries;

    localFields = [];

    addField() {
        // New fields start as plain text; the admin picks the type in the row itself.
        this.localFields.push({
            __uid: nextUid++,
            id: null,
            type: RequestServiceFormFieldType.TEXT,
            label: '',
            key: '',
            required: false,
            settings: null,
            dictionaryId: null,
        });
        this.emitValue();
    }

    onItemInput(index, field) {
        this.localFields.splice(index, 1, field);
        this.emitValue();
    }

    onItemRemove(index) {
        this.localFields.splice(index, 1);
        this.emitValue();
    }

    emitValue() {
        this.$emit('input', this.localFields);
    }

    @Watch('value', { immediate: true })
    onValuePropChange(value) {
        // emitValue() hands the parent this very array, and v-model hands it straight back. Without
        // this guard every keystroke would re-map the list with fresh __uid keys, so Vue would tear
        // down and rebuild the row being edited — and the input would lose focus mid-word.
        if (value === this.localFields) {
            return;
        }

        this.localFields = (value || []).map((field) => ({ __uid: nextUid++, ...field }));
    }
}

export default FormFieldConstructor;
</script>
<style lang="scss">
.form-field-constructor {
    &__empty {
        margin: 0 0 16px;
        padding: 16px;
        background: #f8f8f8;
        border-radius: 10px;
        color: #9b9b9b;
        font-size: 0.875rem;
        line-height: 1.4;
    }

    &__add.button {
        width: 100%;
    }
}
</style>
